<template>
  <div>
    <v-app-bar color="white" style="z-index: 10">
      <v-app-bar-nav-icon
        @click="openCloseMenu"
        style="margin-left: -5px"
      ></v-app-bar-nav-icon>
      <img src="@/assets/logo-sicredi.png" class="ml-10" />
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        rounded
        class="px-12 mr-12"
        @click="
          $route.name == 'ViewSimulacaoChat'
            ? quitSimulacao(1)
            : $router.push('/propostas/nova-simulacao')
        "
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        NOVA SIMULAÇÃO
      </v-btn>
      <Notificacoes />
      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-avatar v-bind="attrs" v-on="on" color="primary" class="mr-4">
              <v-icon dark>mdi-account-circle</v-icon>
            </v-avatar>
          </template>
          <v-list class="p-nav">
            <v-list-item
              class="p-nav-lista"
              v-for="(item, index) in items"
              :key="index"
            >
              <v-list-item
                v-if="item.logout"
                :class="item.class"
                @click="logoff()"
              >
                {{ item.title }}
              </v-list-item>
              <v-list-item v-if="item.name" :class="item.class">
                {{ item.title }}
              </v-list-item>
              <v-list-item
                v-if="item.cookie"
                :class="item.class"
                @click="changeRoute('/politica-cookies')"
              >
                {{ item.title }}
              </v-list-item>
              <v-list-item
                v-if="item.privacy"
                :class="item.class"
                @click="changeRoute('/politica-privacidade')"
              >
                {{ item.title }}
              </v-list-item>
              <v-list-item
                v-if="item.changePass"
                :class="item.class"
                @click="changePassDialog = !changePassDialog"
              >
                {{ item.title }}
              </v-list-item>
              <v-list-item v-if="item.version" :class="item.class">
                {{ item.title }}
              </v-list-item>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <PChangePasswordModal v-model="changePassDialog" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { store } from 'pioneira-ui';
import Notificacoes from '@/components/Notificacoes.vue';
import { PChangePasswordModal } from 'pioneira-ui';

export default {
  components: {
    Notificacoes,
    PChangePasswordModal,
  },
  data: () => ({
    changePassDialog: false,
    items: [
      {
        title: store.state.user.name,
        class: 'p-nav-name',
        name: true,
      },
      {
        title: 'Alterar Senha',
        class: 'p-nav-sair',
        changePass: true,
      },
      {
        title: 'Sair da Conta',
        class: 'p-nav-sair',
        logout: true,
      },
      {
        title: 'Política de Cookies',
        class: 'p-nav-sair',
        cookie: true,
      },
      {
        title: 'Política de Privacidade',
        class: 'p-nav-sair',
        privacy: true,
      },
      {
        title: 'Versão ' + process.env.VUE_APP_VERSION,
        class: 'p-nav-versao',
        version: true,
      },
    ],
  }),
  methods: {
    ...mapActions('ModuleMenuLateral', { openCloseMenu: 'openCloseMenu' }),
    ...mapActions('ModuleSimulacao', { quitSimulacao: 'quitSimulacao' }),

    logoff() {
      store.commit('logoff');
      this.$router.push({ name: 'Acesso' });
    },

    changeRoute(route) {
      const publicPath = process.env.VUE_APP_PUBLIC_PATH || '';
      const url = `${window.location.origin}/${publicPath}${route}`;
      window.open(url, '_blank');

      this.tabs = !this.tabs;
    },
  },
};
</script>

<style>
.p-nav {
  width: 246px;
}
.p-nav-lista {
  font-family: 'Exo';
  min-height: 30px;
  font-style: normal;
}
.p-nav-name {
  font-weight: 800;
  font-size: 15px;
  line-height: 20px;
  color: #1a1a1a;
  padding-left: 0px;
  border-bottom: 1px solid #cccccc;
}
.p-nav-sair {
  font-weight: 400;
  font-size: 16px;

  line-height: 24px;
  color: #1a1a1a;
  padding-left: 0px;
  border-bottom: 1px solid #cccccc;
}
.p-nav-sair:hover {
  background-color: #fff;
}
.p-nav-versao {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding-left: 0px;
  color: #8c8c8c;
}
</style>
